import { render, staticRenderFns } from "./06a_InAktion.vue?vue&type=template&id=36efbe39&"
import script from "./06a_InAktion.vue?vue&type=script&lang=js&"
export * from "./06a_InAktion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports